import { createContext, useContext } from 'react';
import type { EigPanel } from '../../../../lib/eigentuemer/rollen';
import type { PortalZustand } from '../../../../lib/eigentuemer/liste';
import type { PortfolioWerte } from '../../../../lib/eigentuemer/detail';
import type { EigBereich, EigDetailDaten } from '../../../../lib/eigentuemer/useEigentuemerDetail';

/** Abgeleitete Werte der Eigentümer-Detailseite – einmal berechnet, von Widgets und Panels gelesen. */
export interface EigSeitenWert {
  daten: EigDetailDaten;
  fehler: Partial<Record<EigBereich, string>>;
  name: string;
  email: string;
  telefon: string;
  portal: PortalZustand;
  portfolio: PortfolioWerte;
  heute: string;
  zusammenfassung: string;
  oeffnePanel: (key: EigPanel) => void;
  neuLaden: () => void;
  /** Formulare mit ungespeicherten Änderungen melden hier ihre Rückfrage an (null = abmelden). */
  registriereVerlassen: (rueckfrage: (() => void) | null) => void;
  schliessePanel: () => void;
  zumObjekt: (objektId: string) => void;
}

export const EigSeitenKontext = createContext<EigSeitenWert | null>(null);

export function useEigSeite(): EigSeitenWert {
  const w = useContext(EigSeitenKontext);
  if (!w) throw new Error('useEigSeite außerhalb der Eigentümer-Detailseite');
  return w;
}
